(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bfm-abonnement"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const form = root.closest('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const bloc = root.querySelector('[data-freq]');
    const sel = root.querySelector('[data-plans]');
    let champ = form.querySelector('input[name="selling_plan"]');
    if (!champ) {
      champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = 'selling_plan';
      form.appendChild(champ);
    }
    const maj = () => {
      const abo = root.querySelector('input[value="abo"]').checked;
      bloc.hidden = !abo;
      champ.value = abo ? sel.value : '';
      champ.disabled = !abo;
    };
    root.querySelectorAll('input[name="bfm-abo-mode"]').forEach((r) =>
      r.addEventListener('change', maj));
    sel.addEventListener('change', maj);
    maj();
  };
  const scan = () => document.querySelectorAll('[data-bfm-abo]').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bfm-ajouts"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.pret) return;
    const form = document.getElementById(root.dataset.form);
    if (!form) return;
    root.dataset.pret = '1';

    form.addEventListener('submit', (e) => {
      const coches = [...root.querySelectorAll('input[data-vid]:checked')];
      if (!coches.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // La variante choisie l'emporte sur la première : sans ça l'ourson
        // partait toujours en rose, quelle que soit la couleur demandée.
        const items = coches.map((c) => {
          const choix = c.closest('li') && c.closest('li').querySelector('[data-choix]');
          return { id: Number((choix && choix.value) || c.dataset.vid), quantity: 1 };
        });
      const alerte = root.querySelector('[data-ajouts-erreur]');
      const bouton = form.querySelector('[type="submit"]');
      if (alerte) { alerte.hidden = true; alerte.textContent = ''; }
      if (bouton) bouton.setAttribute('aria-busy', 'true');

      // Un échec d'ajout ne doit JAMAIS laisser passer le produit principal seul :
      // le client croirait avoir commandé un vase ou des chocolats sans les avoir.
      // On garde donc les cases cochées, on annonce l'erreur et on ne soumet rien.
      const echouer = () => {
        if (bouton) bouton.removeAttribute('aria-busy');
        if (alerte) {
          alerte.textContent = root.dataset.erreur ||
            "L'ajout n'a pas pu être effectué. Vérifiez votre connexion, puis réessayez.";
          alerte.hidden = false;
          alerte.scrollIntoView({ block: 'nearest' });
        }
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((r) => { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(() => {
          coches.forEach((c) => { c.checked = false; });
          if (bouton) bouton.removeAttribute('aria-busy');
          HTMLFormElement.prototype.submit.call(form);
        })
        .catch(echouer);
    }, true);
  };
  const scan = () => document.querySelectorAll('.bfm-ajouts').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bfm-code-postal"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const champ = root.querySelector('[data-cp]');
    const res = root.querySelector('[data-res]');
    const marge = Number(root.dataset.marge || 0);
    const mode = root.dataset.mode || 'fixe';
    const argent = (n) => n.toLocaleString('fr-CA',
      {style: 'currency', currency: 'CAD', minimumFractionDigits: 0}).replace(/ /g, ' ');
    const chercher = () => {
      const d = window.BFM_LIVRAISON;
      const brut = (champ.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      res.hidden = false;
      root.classList.remove('bfm-cp--oui', 'bfm-cp--non');
      if (!d) { res.textContent = root.dataset.chargement || '…'; return; }
      if (brut.length < 3) {
        res.textContent = champ.dataset.court || 'Entrez les trois premiers caractères, par exemple H1T.';
        return;
      }
      const cle = brut.slice(0, 3);
      const cout = d.tarifs[cle];
      if (cout === undefined) {
        root.classList.add('bfm-cp--non');
        res.textContent = 'Nous ne livrons pas à ' + cle + '. Le ramassage en boutique reste possible'
          + (root.dataset.ramassage === 'true' ? ', sans frais.' : '.');
        return;
      }
      const prix = mode === 'pourcent' ? cout * (1 + marge / 100) : cout + marge;
      const sect = d.secteurs[cle.slice(0, 2)] || '';
      root.classList.add('bfm-cp--oui');
      res.textContent = 'Oui, nous livrons à ' + cle + (sect ? ' — ' + sect : '')
        + '. Livraison ' + argent(Math.round(prix)) + '.';
    };
    root.querySelector('[data-go]').addEventListener('click', chercher);
    champ.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); chercher(); }
    });
  };
  const scan = () => document.querySelectorAll('[data-bfm-cp]').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bfm-date-livraison"] && !Shopify.designMode) return;
  try {
    (() => {
  const TZ = 'America/Toronto';
  const ymd = (d) => new Intl.DateTimeFormat('en-CA',
    {timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'}).format(d);
  const heures = (d) => {
    const f = new Intl.DateTimeFormat('en-CA',
      {timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false}).formatToParts(d);
    const g = (t) => Number(f.find((p) => p.type === t).value);
    return {h: g('hour') % 24, m: g('minute'), s: g('second')};
  };
  const enLettres = (iso) => new Intl.DateTimeFormat('fr-CA',
    {timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long'}).format(new Date(iso + 'T12:00:00'));

  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const input = root.querySelector('.bfm-dl-i');
    const urg = root.querySelector('[data-urg]');
    const msg = root.querySelector('[data-msg]');
    if (!msg || !urg) return;  // le champ peut être masqué : le décompte vit sans lui

    const tombee = Number(root.dataset.tombee || 13);
    const fermes = (root.dataset.fermes || '').split(',').map((x) => x.trim()).filter(Boolean).map(Number);
    const T = {avant: root.dataset.avant, bientot: root.dataset.bientot, apres: root.dataset.apres};

    const ouvrable = (d) => !fermes.includes(new Date(ymd(d) + 'T12:00:00').getDay());
    const prochain = (saut) => {
      const d = new Date();
      d.setDate(d.getDate() + saut);
      for (let i = 0; i < 14 && !ouvrable(d); i++) d.setDate(d.getDate() + 1);
      return d;
    };

    let dernierMin = null;

    const tick = () => {
      const p = heures(new Date());
      const restant = tombee * 3600 - (p.h * 3600 + p.m * 60 + p.s);
      const ouvert = restant > 0 && ouvrable(new Date());
      const min = ymd(prochain(ouvert ? 0 : 1));

      if (input && min !== dernierMin) {
        dernierMin = min;
        input.min = min;
        if (!input.value || input.value < min) input.value = min;
        const max = new Date(min + 'T12:00:00');
        max.setDate(max.getDate() + 365);
        input.max = ymd(max);
      }

      let txt;
      if (ouvert) {
        const h = Math.floor(restant / 3600);
        const m = Math.floor((restant % 3600) / 60);
        const sec = restant % 60;
        const t = h > 0
          ? h + ' h ' + String(m).padStart(2, '0')
          : (m > 0 ? m + ' min ' + String(sec).padStart(2, '0') : sec + ' s');
        txt = (restant <= 3600 ? T.bientot : T.avant).replace('{temps}', t);
        urg.classList.toggle('bfm-dl-chaud', restant <= 3600);
      } else {
        txt = T.apres.replace('{date}', enLettres(min));
        urg.classList.remove('bfm-dl-chaud');
      }
      msg.textContent = txt;
      urg.hidden = false;
    };

    tick();
    setInterval(tick, 1000);
    if (input) {
      input.addEventListener('change', () => {
        if (input.value && input.value < input.min) input.value = input.min;
      });
    }
  };

  const scan = () => document.querySelectorAll('.bfm-dl').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bfm-detail-format"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const src = root.querySelector('[data-detf]');
    const out = root.querySelector('[data-txt]');
    if (!src || !out) return;
    let map = {};
    try { map = JSON.parse(src.textContent); } catch (e) { return; }

    const champ = () => {
      const f = root.closest('.shopify-section') || document;
      return f.querySelector('input[name="id"], select[name="id"]');
    };

    let dernier = null;
    const maj = () => {
      const c = champ();
      if (!c || c.value === dernier) return;
      dernier = c.value;
      const t = map[String(c.value)];
      out.textContent = t || '';
      root.style.display = t ? '' : 'none';
    };

    maj();
    // Avant : setInterval(maj, 300) interrogeait le DOM plus de 3 fois par seconde
    // pendant toute la visite. On réagit maintenant aux vrais changements.
    document.addEventListener('change', maj, true);
    const zone = root.closest('.shopify-section') || document.body;
    const obs = new MutationObserver(maj);
    obs.observe(zone, { subtree: true, childList: true,
                        attributes: true, attributeFilter: ['value', 'selected', 'checked'] });
  };
  const scan = () => document.querySelectorAll('.bfm-detf').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bfm-message-carte"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (r) => {
    if (r.dataset.pret) return; r.dataset.pret = '1';
    const t = r.querySelector('.bfm-msg-i'), c = r.querySelector('[data-compte]');
    if (!t || !c) return;
    const maj = () => { c.textContent = t.value.length; };
    t.addEventListener('input', maj); maj();
  };
  const scan = () => document.querySelectorAll('.bfm-msg').forEach(init);
  document.addEventListener('DOMContentLoaded', scan); scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
